// extracted by mini-css-extract-plugin
export default {"modal":"ArchiveJobsModal-module__modal__GSDUH","detail":"ArchiveJobsModal-module__detail__G2LSl"};